import { connect, MapStateToProps } from "react-redux";

import { DropdownItem, DropdownItemProps } from "@multiweb/dropdown";
import { bridge } from "@multiweb/reactCore/bridge";
import {
    getActionIconCode,
    getActionLocKey,
} from "@multiweb/reactCore/datasource";
import { getPrimaryText, getSecondaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";

const { executeReactConnectorAction } = bridge;

export type RowActionDropdownItemProps = {
    /** Unikátní klíč pro DataSource. */
    dataSourceKey: string;
    /** Identifikátor řádku, na kterém se akce nachází. */
    recordId: string;
    /** Identifikátor akce, která se má zobrazit. */
    actionId: string;
    /** Určuje, zda jsou akce zakázány. */
    disabled?: boolean;
};

type StateProps = Pick<DropdownItemProps, "clickAction">;

const mapStateToProps: MapStateToProps<StateProps, RowActionDropdownItemProps, IAppState> = (
    state,
    { dataSourceKey, actionId, recordId },
) => ({
    clickAction: {
        title: getSecondaryText(state, getActionLocKey(state, { dataSourceKey, actionId }) || "") || "",
        text: getPrimaryText(state, getActionLocKey(state, { dataSourceKey, actionId }) || ""),
        icon: getActionIconCode(state, { dataSourceKey, actionId }),
        onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
            executeReactConnectorAction(dataSourceKey, actionId, recordId);
            event.stopPropagation();
        },
    },
});

export const RowActionDropdownItem = connect(mapStateToProps)(DropdownItem);
